import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=2c8782ab&"
import script from "./PaginationControls.vue?vue&type=script&lang=js&"
export * from "./PaginationControls.vue?vue&type=script&lang=js&"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8782ab')) {
      api.createRecord('2c8782ab', component.options)
    } else {
      api.reload('2c8782ab', component.options)
    }
    module.hot.accept("./PaginationControls.vue?vue&type=template&id=2c8782ab&", function () {
      api.rerender('2c8782ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/Table/PaginationControls.vue"
export default component.exports